module.exports = __webpack_public_path__ + "static/media/about3.7f7efa83.jpg";